/* eslint-disable no-unused-vars */
import React from 'react'
import { Navigate } from 'react-router-dom'

const PrivateRoute = ({ children }) => {
    const orgId = localStorage.getItem('orgId')
    const userId = localStorage.getItem('userId')
    const isAuthenticated = orgId && userId
    // return children
    return isAuthenticated ? children : <Navigate to="/" />
}

export default PrivateRoute
